/**
 * This file is auto-generated using abi-gen. Don't edit directly.
 * Templates can be found at https://github.com/0xProject/0x.js/tree/development/packages/abi-gen-templates.
 */
// tslint:disable-next-line:no-unused-variable
import { TxData, PolicyRegistryEntry, PolicyRegistryEntryData } from '../../types';
import { BigNumber } from '../../utils/bignumber';
import { classUtils } from '../../utils/classUtils';
import { promisify } from '../../utils/promisify';
import { PolicyRegistry as ContractArtifacts } from '../../artifacts/PolicyRegistry';
import * as Web3 from 'web3';

import { BaseContract } from './base_contract_wrapper';
import { Web3Utils } from '../../utils/web3_utils';

export class PolicyRegistryContract extends BaseContract {
    public registry = {
        async callAsync(
            index_0: string,
            defaultBlock?: Web3.BlockParam
        ): Promise<[string, string, string, BigNumber, BigNumber, BigNumber]> {
            const self = this as PolicyRegistryContract;
            const result = await promisify<
                [string, string, string, BigNumber, BigNumber, BigNumber]
            >(self.web3ContractInstance.registry.call, self.web3ContractInstance)(index_0);
            return result;
        }
    };
    public policyCount = {
        async callAsync(defaultBlock?: Web3.BlockParam): Promise<BigNumber> {
            const self = this as PolicyRegistryContract;
            const result = await promisify<BigNumber>(
                self.web3ContractInstance.policyCount.call,
                self.web3ContractInstance
            )();
            return result;
        }
    };
    public NULL_ISSUANCE_HASH = {
        async callAsync(defaultBlock?: Web3.BlockParam): Promise<string> {
            const self = this as PolicyRegistryContract;
            const result = await promisify<string>(
                self.web3ContractInstance.NULL_ISSUANCE_HASH.call,
                self.web3ContractInstance
            )();
            return result;
        }
    };
    public fillPolicyOrder = {
        async sendTransactionAsync(
            _carrier: string,
            _orderHash: string,
            _quoteHash: string,
            _coverage: BigNumber,
            _premium: BigNumber,
            _expirationTimestampInSec: BigNumber,
            _carrierSignatureV: number | BigNumber,
            _carrierSignatureR: string,
            _carrierSignatureS: string,
            txData: TxData = {}
        ): Promise<string> {
            const self = this as PolicyRegistryContract;
            const txDataWithDefaults = await self.applyDefaultsToTxDataAsync(
                txData,
                self.fillPolicyOrder.estimateGasAsync.bind(
                    self,
                    _carrier,
                    _orderHash,
                    _quoteHash,
                    _coverage,
                    _premium,
                    _expirationTimestampInSec,
                    _carrierSignatureV,
                    _carrierSignatureR,
                    _carrierSignatureS
                )
            );
            const txHash = await promisify<string>(
                self.web3ContractInstance.fillPolicyOrder,
                self.web3ContractInstance
            )(
                _carrier,
                _orderHash,
                _quoteHash,
                _coverage,
                _premium,
                _expirationTimestampInSec,
                _carrierSignatureV,
                _carrierSignatureR,
                _carrierSignatureS,
                txDataWithDefaults
            );
            return txHash;
        },
        async estimateGasAsync(
            _carrier: string,
            _orderHash: string,
            _quoteHash: string,
            _coverage: BigNumber,
            _premium: BigNumber,
            _expirationTimestampInSec: BigNumber,
            _carrierSignatureV: number | BigNumber,
            _carrierSignatureR: string,
            _carrierSignatureS: string,
            txData: TxData = {}
        ): Promise<number> {
            const self = this as PolicyRegistryContract;
            const txDataWithDefaults = await self.applyDefaultsToTxDataAsync(txData);
            const gas = await promisify<number>(
                self.web3ContractInstance.fillPolicyOrder.estimateGas,
                self.web3ContractInstance
            )(
                _carrier,
                _orderHash,
                _quoteHash,
                _coverage,
                _premium,
                _expirationTimestampInSec,
                _carrierSignatureV,
                _carrierSignatureR,
                _carrierSignatureS,
                txDataWithDefaults
            );
            return gas;
        },
        async getABIEncodedTransactionData(
            _carrier: string,
            _orderHash: string,
            _quoteHash: string,
            _coverage: BigNumber,
            _premium: BigNumber,
            _expirationTimestampInSec: BigNumber,
            _carrierSignatureV: number | BigNumber,
            _carrierSignatureR: string,
            _carrierSignatureS: string,
            txData: TxData = {}
        ): Promise<string> {
            const self = this as PolicyRegistryContract;
            const txDataWithDefaults = await self.applyDefaultsToTxDataAsync(txData);
            const abiEncodedTransactionData = await promisify<string>(
                self.web3ContractInstance.fillPolicyOrder.getData,
                self.web3ContractInstance
            )(
                _carrier,
                _orderHash,
                _quoteHash,
                _coverage,
                _premium,
                _expirationTimestampInSec,
                _carrierSignatureV,
                _carrierSignatureR,
                _carrierSignatureS,
                txDataWithDefaults
            );
            return abiEncodedTransactionData;
        }
    };
    public getPolicyEntry = {
        async callAsync(applicationHash: string): Promise<PolicyRegistryEntry> {
            const self = this as PolicyRegistryContract;
            const result = await promisify<PolicyRegistryEntryData>(
                self.web3ContractInstance.getPolicyEntry.call,
                self.web3ContractInstance
            )(applicationHash);
            return PolicyRegistryEntry.fromData(result);
        }
    };
    async deploy(...args: any[]): Promise<any> {
        const wrapper = this;
        const rejected = false;

        return new Promise((resolve, reject) => {
            wrapper.web3ContractInstance.new(
                wrapper.defaults,
                (err: string, contract: Web3.ContractInstance) => {
                    if (err) {
                        reject(err);
                    } else if (contract.address) {
                        wrapper.web3ContractInstance = wrapper.web3ContractInstance.at(
                            contract.address
                        );
                        wrapper.address = contract.address;
                        resolve();
                    }
                }
            );
        });
    }
    public static async deployed(
        web3: Web3,
        defaults: Partial<TxData>
    ): Promise<PolicyRegistryContract> {
        const web3Utils = new Web3Utils(web3);

        const currentNetwork = await web3Utils.getNetworkIdAsync();
        const { abi, networks }: { abi: any; networks: any } = ContractArtifacts;

        if (networks[currentNetwork]) {
            const { address: contractAddress } = networks[currentNetwork];

            const contractExists = await web3Utils.doesContractExistAtAddressAsync(contractAddress);
            if (contractExists) {
                const web3ContractInstance = web3.eth.contract(abi).at(contractAddress);
                return new PolicyRegistryContract(web3ContractInstance, defaults);
            } else {
                throw new Error('Contract not found on network');
            }
        } else {
            throw new Error('Contract not found on network');
        }
    }

    public static async at(
        address: string,
        web3: Web3,
        defaults: Partial<TxData>
    ): Promise<PolicyRegistryContract> {
        const web3Utils = new Web3Utils(web3);
        const { abi }: { abi: any } = ContractArtifacts;
        const contractExists = await web3Utils.doesContractExistAtAddressAsync(address);
        const currentNetwork = await web3Utils.getNetworkIdAsync();

        if (contractExists) {
            const web3ContractInstance = web3.eth.contract(abi).at(address);
            return new PolicyRegistryContract(web3ContractInstance, defaults);
        } else {
            throw new Error('Contract not found on network');
        }
    }

    constructor(web3ContractInstance: Web3.ContractInstance, defaults: Partial<TxData>) {
        super(web3ContractInstance, defaults);
        classUtils.bindAll(this, ['web3ContractInstance', 'defaults']);
    }
} // tslint:disable:max-file-line-count
